export const pageTitle = (game: string, bookUnit: string, grade: number) => {
  const title = [game, bookUnit, `Primary ${grade}`, "Space Town Go"];
  return title.join(" | ");
};

export const random = (max: number) => {
  return Math.floor(Math.random() * max);
};

export const timeout = (ms: number): Promise<any> => {
  return new Promise((resolve) => setTimeout(resolve, ms));
};

export const audioErr = (src: string) => {
  console.log(`Audio Not Found:\n${src}`);
};

export const explodeArray = (array: any[]): any[] => {
  if (Array.isArray(array[0])) {
    const newArray = array.reduce((acc, cur) => acc.concat(cur), []);
    return Array.isArray(newArray[0]) ? explodeArray(newArray) : newArray;
  }
  return array;
};

export const displayLetter = (phonics: string): string => {
  if (!phonics) return "";
  phonics = phonics.replace(/#/g, '');
  if (!phonics.includes("_")) return phonics;
  return phonics
    .split("_")
    .filter((p) => !/\d/.test(p))
    .join("_");
};

export const backToWeb = (
  book: string,
  webUrl: string,
  grade: number,
  unit: number
) => {
  let url: string;
  if (book === "small_book") {
    let bookShelf = "small_book_big_shelf";
    if (grade === 1 && unit <= 4) bookShelf = "small_book_shelf";
    url = `${webUrl}${bookShelf}.php?unit=unit${unit}&primary=${grade}&type=${book}`;
  } else {
    url = `${webUrl}sound_book_selection.php?primary=${grade}`;
  }
  window.location.href = url;
};

export const findJsonValue = (
  obj: any[],
  key: string,
  { grade, unit, game }: { grade: number; unit: number; game?: number },
  isArray: boolean = false
) => {
  let value: any = isArray ? [] : null;
  obj.some((b) => {
    if (b.grade === grade) {
      if (b[key] || b[key] === 0) value = b[key];

      b.units.some((u) => {
        let found: boolean = false;
        if (game && u.unit === unit) {
          found = u.games.some((g) => {
            if (g.game === game && (g[key] || g[key] === 0)) {
              value = g[key];
              return true;
            }
            return false;
          });
        }

        if (!found && u.unit === unit && (u[key] || u[key] === 0)) {
          value = u[key];
          return true;
        }
        return false;
      });
      return true;
    }
    return false;
  });
  return value;
};
